"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Heart = function Heart(_ref) {
    var _ref$circleSize = _ref.circleSize,
        circleSize = _ref$circleSize === undefined ? "28px" : _ref$circleSize,
        _ref$heartSize = _ref.heartSize,
        heartSize = _ref$heartSize === undefined ? "18px" : _ref$heartSize,
        heartColor = _ref.heartColor,
        isFavorited = _ref.isFavorited,
        _ref$padding = _ref.padding,
        padding = _ref$padding === undefined ? "6px 5px 5px 5px" : _ref$padding;


    var circleStyles = {
        width: circleSize,
        height: circleSize,
        padding: padding,
        boxSizing: 'border-box'
    };

    return _react2.default.createElement(
        "div",
        {
            className: "heart-container",
            style: circleStyles
        },
        _react2.default.createElement(
            "svg",
            { width: heartSize, height: heartSize, viewBox: "0 0 16 13", version: "1.1" },
            _react2.default.createElement(
                "g",
                { stroke: "none", "stroke-width": isFavorited ? "0" : "1", fill: isFavorited ? heartColor : "none", "fill-rule": "evenodd", "stroke-linecap": "round", "stroke-linejoin": "round" },
                _react2.default.createElement(
                    "g",
                    { transform: "translate(-6.000000, -8.000000)", stroke: isFavorited ? "none" : "#A3A3A5" },
                    _react2.default.createElement("path", { d: "M20.1793455,14.5240604 C20.6843636,13.9387555 21,13.1963218 21,12.3753236 C21,10.5113829 19.4330182,9 17.5005091,9 C15.5669818,9 14,10.5113829 14,12.3753236 C14,10.5113829 12.4330182,9 10.5005091,9 C8.56698182,9 7,10.5113829 7,12.3753236 C7,13.1963218 7.31563636,13.9387555 7.82065455,14.5240604 L7.78501818,14.5240604 L7.93061818,14.6527096 C8.05789091,14.7862691 8.19636364,14.9041157 8.34298182,15.01607 L14,20 L19.6570182,15.0150879 C19.8036364,14.9041157 19.9431273,14.785287 20.0693818,14.6527096 L20.2149818,14.5240604 L20.1793455,14.5240604 Z" })
                )
            )
        )
    );
};

exports.default = Heart;


//////////////////
// WEBPACK FOOTER
// ./~/pubweb-react-components/dist/components/Favoriting/Heart.js
// module id = 473
// module chunks = 168707334958949